import _helpers from "./dist/helpers";
import _gamut from "./dist/gamut";
import _cam from "./dist/cam";
import _ucs from "./dist/ucs";
import _hq from "./dist/hq";
var exports = {};
var helpers = _helpers,
    gamut = _gamut,
    cam = _cam,
    ucs = _ucs,
    hq = _hq;
exports = {
  gamut: gamut,
  cfs: helpers.cfs,
  lerp: helpers.lerp,
  cam: cam,
  ucs: ucs,
  hq: hq
};
export default exports;
export const cfs = exports.cfs;
const _gamut2 = exports.gamut;
export { _gamut2 as gamut };